const routeMeta = {
  AccountManagementStep: 'accountManagementStep',
  RequiresScheduleStep: 'requiresScheduleStep',
  RequiresPropertyStep: 'requiresPropertyStep',
  RequiresAuthentication: 'requiresAuthentication',
  ShowSummarySidebar: 'showSummarySidebar',
};

export default routeMeta;
